import { render, staticRenderFns } from "./certificate-managers.vue?vue&type=template&id=47522e8f"
import script from "./certificate-managers.vue?vue&type=script&lang=js"
export * from "./certificate-managers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports